module.exports = __webpack_public_path__ + "assets/5c54ed9d3eb72efaa6fa72ae12fbe76c.mp4";